import { config } from "../utils";
import { eventStoreRequest } from "../api/api_event";

/**
 * Sends an event to BI,
 * already includes uid by default
 * @param event string Event name
 * @param data object Event details to track
 */

export const track = (biModel) => {
    const PLATFORM_IOS = 'ios';
    let BiModelJson = null;
    
    try {
        BiModelJson = JSON.stringify(biModel.request);
    } catch (error) {
        console.error(error);
        return;
    }

    return eventStoreRequest(BiModelJson);
};